(() => {
  const normalise = value => value.normalize('NFC').toLocaleLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  function init(root) {
    if (root.dataset.libraryReady) return;
    const entries = [...root.querySelectorAll('[data-library-entry]')];
    const search = root.querySelector('[data-library-search]');
    const alphabet = root.querySelector('[data-library-alphabet]');
    const status = root.querySelector('[data-library-status]');
    if (!entries.length || !search || !alphabet || !status) return;
    root.dataset.libraryReady = 'true';
    let letter = '';
    const update = () => {
      const tokens = normalise(search.value).split(/\s+/).filter(Boolean);
      for (const entry of entries) {
        const label = normalise(entry.dataset.libraryLabel);
        const searchable = label + ' ' + normalise(entry.dataset.libraryDescription || '');
        entry.hidden = !tokens.every(token => searchable.includes(token)) || (!!letter && !label.startsWith(letter));
      }
      for (const group of root.querySelectorAll('[data-library-group]')) group.hidden = ![...group.querySelectorAll('[data-library-entry]')].some(entry => !entry.hidden);
      const count = entries.filter(entry => !entry.hidden).length;
      status.textContent = count ? String(count) : status.dataset.empty;
      for (const button of alphabet.querySelectorAll('button')) button.setAttribute('aria-pressed', String(button.dataset.letter === letter));
    };
    for (const value of ['', ...'abcdefghijklmnopqrstuvwxyz']) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.letter = value;
      button.textContent = value ? value.toUpperCase() : (document.documentElement.lang.startsWith('en') ? 'All' : 'Alle');
      button.disabled = !!value && !entries.some(entry => normalise(entry.dataset.libraryLabel).startsWith(value));
      button.addEventListener('click', () => { letter = value; update(); });
      alphabet.append(button);
    }
    search.addEventListener('input', () => { letter = ''; update(); });
    root.querySelector('[data-library-controls]').hidden = false;
    alphabet.hidden = false;
    update();
  }
  const scan = () => document.querySelectorAll('[data-wynch-library]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
